module.exports = __webpack_public_path__ + "img/hg.ef45a97a.png";